import script from "./QModalSettingsUser.vue?vue&type=script&setup=true&lang=js"
export * from "./QModalSettingsUser.vue?vue&type=script&setup=true&lang=js"

import "./QModalSettingsUser.vue?vue&type=style&index=0&id=d6984a28&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend-demo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6984a28"]])

export default __exports__